// export function AsyncComponentHook(path) {
//     // 通过 webpack 的内联注释,设置模块名
//     let component = import(/* webpackChunkName: "view-[request]" */ `@/views/${path}.vue`);
//     component.catch((e) => {
//         console.error(e);
//     });
//     return component;
// }

// 防抖
export function debounce(fn, delay) {
  var delay = delay || 500;
  var timer;
  return function() {
    var th = this;
    var args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      timer = null;
      fn.apply(th, args);
    }, delay);
  };
}
// 节流
export function throttle(fn, interval) {
  var last;
  var timer;
  var interval = interval || 500;
  return function() {
    var th = this;
    var args = arguments;
    var now = +new Date();
    if (last && now - last < interval) {
      clearTimeout(timer);
      timer = setTimeout(function() {
        last = now;
        fn.apply(th, args);
      }, interval);
    } else {
      last = now;
      fn.apply(th, args);
    }
  };
}

export function isScrollBottom(ele, wrapHeight, threshold = 30) {
  const h1 = ele.scrollHeight - ele.scrollTop;
  const h2 = wrapHeight + threshold;
  const isBottom = h1 <= h2;
  return isBottom;
}

export const getUrlParams = name => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return "";
};

export const stopScroll = () => {
  document.body.addEventListener("touchmove", prevent, {
    passive: false,
    capture: true
  });
  document.body.addEventListener("scroll", prevent, {
    passive: false,
    capture: true
  });
  document.addEventListener("mousewheel", prevent, {
    passive: false,
    capture: true
  });
};
export const enableScroll = () => {
  document.body.removeEventListener("touchmove", prevent, true);
  document.body.removeEventListener("scroll", prevent, true);
  document.removeEventListener("mousewheel", prevent, true);
};
export const stopBodyScroll = context => {
  context.top =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  document.body.style =
    "position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden";
};
export const enableBodyScroll = context => {
  document.body.style = "";
  window.scrollTo(0, context.top);
};
export const prevent = e => {
  e.preventDefault();
};

export const showToast = (context, msg, time = "") => {
  context.$store.commit("updateToast", { status: true, msg, time });
};

export const changeFormState = (context, type) => {
  context.$store.commit("updateFormState", type);
};

export const getObjectStorage = key => {
  let temp = window.localStorage.getItem(key);
  if (temp) return JSON.parse(temp);
  else return "";
};

// export const timeFormat = (value,type) => {
//     if(!value) return ;
//     let t=new Date(value);
//     if(type===1) return t.getFullYear()+"-"+(t.getMonth()+1)+"-"+t.getDate();
//     return t.getFullYear()+"-"+(t.getMonth()+1)+"-"+t.getDate()+" "+t.getHours()+":"+t.getMinutes()+":"+t.getSeconds();
// }

export const timeFormat = (fmt, date) => {
  let ret;
  let t = new Date(date);
  const opt = {
    "Y+": t.getFullYear().toString(), // 年
    "m+": (t.getMonth() + 1).toString(), // 月
    "d+": t.getDate().toString(), // 日
    "H+": t.getHours().toString(), // 时
    "M+": t.getMinutes().toString(), // 分
    "S+": t.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
};

export const arrayResort = (arr, childField = "") => {
  let temp = [];
  for (let i = arr.length - 1; i > -1; i--) {
    const index = Math.floor((i + 1) * Math.random());
    let item = arr.splice(index, 1)[0];
    if (childField && item[childField] && item[childField].length > 0) {
      item[childField] = arrayResort(item[childField], childField);
    }
    temp.push(item);
  }
  return temp;
};

export const isMobile = () => {
  // if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
  //     return true; // 移动端
  // } else {
  //     return false; // PC端
  // }
  const clientWidth =
    window.innerWidth ||
    document.body.clientWidth ||
    document.documentElement.clientWidth;
  return clientWidth <= 768;
};

export const isSafari = () => {
  if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))
    return true;
  return false;
};

/**
 * 随机生成字符串
 * @param len 指定生成字符串长度
 */
export const getRandomString = len => {
  let _charStr =
      "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789",
    min = 0,
    max = _charStr.length - 1,
    _str = ""; //定义随机字符串 变量
  //判断是否指定长度，否则默认长度为15
  len = len || 15;
  //循环生成字符串
  for (var i = 0, index; i < len; i++) {
    index = (function(randomIndexFunc, i) {
      return randomIndexFunc(min, max, i, randomIndexFunc);
    })(function(min, max, i, _self) {
      let indexTemp = Math.floor(Math.random() * (max - min + 1) + min),
        numStart = _charStr.length - 10;
      if (i == 0 && indexTemp >= numStart) {
        indexTemp = _self(min, max, i, _self);
      }
      return indexTemp;
    }, i);
    _str += _charStr[index];
  }
  return _str;
};

export const fixMobileInput = () => {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isiOS) {
    // document.body.addEventListener('focusin', () => {
    //     setTimeout(()=>{
    //           document.body.scrollTop=document.body.scrollHeight;
    //     },100)
    // })
    document.body.addEventListener("focusout", () => {
      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      window.scrollTo({ top, left: 0 });
    });
  }
  if (/Android/gi.test(navigator.userAgent)) {
    window.addEventListener(
      "resize",
      function() {
        if (
          document.activeElement.tagName == "INPUT" ||
          document.activeElement.tagName == "TEXTAREA"
        ) {
          window.setTimeout(function() {
            // document.activeElement.scrollIntoView();
            document.activeElement.scrollIntoViewIfNeeded(true);
          }, 100);
        }
      }.bind(this)
    );
  }
  if (/Android [4-8]/.test(navigator.appVersion)) {
    window.addEventListener("resize", function() {
      if (
        document.activeElement.tagName === "INPUT" ||
        document.activeElement.tagName === "TEXTAREA"
      ) {
        window.setTimeout(function() {
          document.activeElement.scrollIntoViewIfNeeded(true);
        }, 0);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/util/utils.js